@let controlValue = control();

<mat-form-field class="list-filter-form-field">
  <mat-label>{{ label() }}</mat-label>
  <mat-select [formControl]="controlValue">
    @for (statusCode of StatusCodes; track statusCode) {
      <mat-option [value]="statusCode"
        ><cappus-dto-common-status [isActive]="statusCode === 'Active'"
      /></mat-option>
    }
    <mat-select-trigger>
      @let statusCode = controlValue.value;
      @if (statusCode !== null) {
        <cappus-dto-common-status [isActive]="statusCode === 'Active'" />
      }
    </mat-select-trigger>
  </mat-select>
  <cappus-filter-clear-button matSuffix [control]="controlValue" />
</mat-form-field>
